<template>
  <v-speed-dial
    v-if="!isOnline"
    v-model="open"
    bottom
    right
    direction="left"
    transition="scale-transition"
    class="offline-popup"
  >
    <template v-slot:activator>
      <v-btn v-model="open" color="blue darken-2" aria-label="Zamknij" dark fab>
        <v-icon>mdi-wifi-strength-off-outline</v-icon>

        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </template>

    <v-card style="min-width: 200px">
      <v-card-text role="alert">
        Wystąpił problem z połączeniem internetowym
      </v-card-text>
    </v-card>
  </v-speed-dial>
</template>

<script>
import { connectionMixin } from '@/mixins/connection';

// @vuese
// Popup informujący o braku połączenia internetowego
// @group popup
export default {
  mixins: [connectionMixin],
  data() {
    return {
      open: false
    };
  }
};
</script>

<style>
.offline-popup {
  z-index: 100;
  position: fixed !important;
}
</style>
